import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
// The salesman area is hidden. Its components still live under
// src/components/salesman/ and src/SalesMan.js - re-import them and restore the
// /SalesMan and /components/salesman/* routes below to turn it back on.
import Home from '../pages/Home/Home';
import ProductList from '../ProductList';
import New_Product from '../New_Product';
import All_P from '../All_P';
import CustomerDashboard from '../components/customer/CustomerDashboard';
import Demo from '../pages/Demo/Demo';
import OrderByComp_Customer from '../components/customer/OrderByComp_Customer';
import OrderGeneric from '../components/customer/OrderGeneric';
import CompanyDashboard from '../components/company/CompanyDashboard';
import Ledger from '../components/customer/Ledger';
import PendingBills from '../components/customer/PendingBills';
import BounceList from '../components/customer/BounceList';
import BillTracking from '../components/customer/BillTracking';
import OrderList from '../components/customer/OrderList';
import DownloadInvoice from '../components/customer/DownLoadInvoice';
import PaymentReceipts from '../components/customer/PaymentReceipts';
import Company from '../LoginPages/Company';
import Customer from '../LoginPages/Customer';
import LoginChooser from '../LoginPages/LoginChooser';
import OrderUpload from '../pages/DocUpload/OrderUpload';
import { useSelector } from 'react-redux';
import { Button, Result } from 'antd';
// const OrderUpload = lazy(() => import('../pages/DocUpload/OrderUpload'));

// lazy so the bank details / QR stay out of the public bundle
const AccountInfo = lazy(() => import('../components/customer/AccountInfo'));
// The separate Shimoga portal (src/shimoga) - its own screens, store and
// storage. Lazy, so it is only downloaded when someone opens /Shimoga.
const ShimogaRoutes = lazy(() => import('../shimoga/ShimogaRoutes'));

const RoutesComponents = () => {
  const data = useSelector((state) => state.userSlice);
  console.log({ UserData: window.location.pathname });
  const loggedIn = data.login;
  // a company rep's session must not open the customer dashboard at /Customer
  const asCustomer = loggedIn && localStorage.getItem("app-type") !== "Com";

  return (
    <>
      <Route exact path='/' component={Home} />
      <Route path='/Shimoga' component={ShimogaRoutes} />
      <Route exact path='/Customer' component={asCustomer ? CustomerDashboard : Customer} />
      <Route exact path='/Company' component={Company} />
      {/* Login As -> choose Udupi / Vetrem or Shimoga, with each one's status */}
      <Route exact path='/Login/:type' component={LoginChooser} />
      <Route path='/ProductList' component={ProductList} />
      <Route exact path='/New_Product' component={New_Product} />
      {loggedIn ? <>
        <Route exact path='/All_P' component={All_P} />
        <Route exact path='/Demo' component={Demo} />
        <Route exact path='/components/customer/CustomerDashboard' component={CustomerDashboard} />
        <Route exact path='/components/customer/OrderByComp_Customer' component={OrderByComp_Customer} />
        <Route exact path='/components/customer/OrderGeneric' component={OrderGeneric} />
        <Route exact path='/components/company/CompanyDashboard' component={CompanyDashboard} />
        <Route exact path='/components/customer/Ledger' component={Ledger} />
        <Route exact path='/components/customer/PendingBills' component={PendingBills} />
        <Route exact path='/components/customer/BounceList' component={BounceList} />
        <Route exact path='/components/customer/BillTracking' component={BillTracking} />
        <Route exact path='/components/customer/OrderList' component={OrderList} />
        <Route exact path='/components/customer/DownLoadInvoice' component={DownloadInvoice} />
        <Route exact path='/components/customer/PaymentReceipts' component={PaymentReceipts} />
        <Route exact path='/components/customer/AccountInfo' component={AccountInfo} />
        <Route exact path='/OrderUpload/' component={OrderUpload} />
      </> : <>
        {(
          !window.location.pathname.startsWith("/Shimoga") &&
          window.location.pathname !== "/" &&
          window.location.pathname !== "/Company" &&
          window.location.pathname !== "/ProductList" &&
          window.location.pathname !== "/New_Product" &&
          window.location.pathname !== "/Customer" &&
          !window.location.pathname.startsWith("/Login/")

        ) && < Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited needs login."
            extra={<Button onClick={() => window.location.replace("/")} type="primary">Back Home</Button>}
          />
        }
      </>
      }
    </>
  )
}
export default RoutesComponents;